import { Overview } from '.';

const routes = [
    {
        path: '/overview',
        element: <Overview />,
        title: 'Synthnode Overview'
    }
]

export default routes;